import axios from 'axios'
import { notification } from 'antd'

const API_URL = window.config.api

const THEME_UPDATE = 'https://www.indytheme.com/api/v1.0/theme-update/check'
const HEALTH_CHECK = `${API_URL}/health_check`
const INIT_CHECK = `${API_URL}/init_check`
const INSTALL_TEMPLATE = `${API_URL}/install_template`
const UPLOAD_IMAGE = `${API_URL}/upload_image`
const ACTIVATE = `${API_URL}/ac_setting`
const APP_CONFIG = `${API_URL}/app_config`
const HEADER_CONFIG = `${API_URL}/header_config`
const FOOTER_CONFIG = `${API_URL}/footer_config`
const MAIN_MENU_LIST = `${API_URL}/main_menu_list`
const CATEGORY_MENU_LIST = `${API_URL}/category_menu_list`
const ALL_CATEGORIES = `${API_URL}/all_categories`
const ALL_PRODUCT_CATEGORIES = `${API_URL}/all_product_categories`
const CATEGORY_URL = `${API_URL}/category_url`
const CATEGORY_INFO = `${API_URL}/category_info`
const LAYOUTS = `${API_URL}/layouts`
const LAYOUT_REMOVE = `${API_URL}/layout/remove`
const COLUMNS = `${API_URL}/columns`
const COLUMNS_ADD = `${API_URL}/columns/add`
const CATEGORY_BANNERS = `${API_URL}/category_banners`
const CATEGORY_BANNER = `${API_URL}/category_banner`
const CATEGORY_BANNER_UPDATE = `${API_URL}/category_banner/update`
const CATEGORY_BANNER_DELETE = `${API_URL}/category_banner/delete`
const ADDITIONAL_CSS = `${API_URL}/additional_css`

const CLIENT_KEY = 'd67ab0c73cf487cf8e1db65975f47f79'
const THEME_NAME_ENCODE = 'nJ5xrJ1uoTj='

export const getThemeUpdate = async props =>
    axios({
        method: 'GET',
        url: `${THEME_UPDATE}?key=${CLIENT_KEY}&tne=${THEME_NAME_ENCODE}&v=${new Date().getTime()}`
    })

export const checkHealth = async props =>
    callApi({
        ...props,
        url: HEALTH_CHECK,
        method: 'GET'
    })

export const checkInit = async props =>
    callApi({
        ...props,
        url: INIT_CHECK,
        method: 'GET'
    })

export const getTemplates = async props =>
    callApi({
        ...props,
        url: INSTALL_TEMPLATE,
        method: 'GET'
    })

export const setTemplate = async props =>
    callApi({
        ...props,
        url: INSTALL_TEMPLATE,
        method: 'POST'
    })

export const uploadImage = async props =>
    callApi({
        ...props,
        url: UPLOAD_IMAGE,
        method: 'POST',
        type: 'MULTIPART'
    })

export const activate = async props =>
    callApi({
        ...props,
        url: ACTIVATE,
        method: 'POST'
    })

export const getAppConfig = async props =>
    callApi({
        ...props,
        url: APP_CONFIG,
        method: 'GET'
    })

export const setAppConfig = async props =>
    callApi({
        ...props,
        url: APP_CONFIG,
        method: 'POST'
    })

export const getHeaderConfig = async props =>
    callApi({
        ...props,
        url: HEADER_CONFIG,
        method: 'GET'
    })

export const setHeaderConfig = async props =>
    callApi({
        ...props,
        url: HEADER_CONFIG,
        method: 'POST'
    })

export const getFooterConfig = async props =>
    callApi({
        ...props,
        url: FOOTER_CONFIG,
        method: 'GET'
    })

export const setFooterConfig = async props =>
    callApi({
        ...props,
        url: FOOTER_CONFIG,
        method: 'POST'
    })

export const getMainMenuList = async props =>
    callApi({
        ...props,
        url: MAIN_MENU_LIST,
        method: 'GET'
    })

export const setMainMenuList = async props =>
    callApi({
        ...props,
        url: MAIN_MENU_LIST,
        method: 'POST'
    })

export const getCategoryMenuList = async props =>
    callApi({
        ...props,
        url: CATEGORY_MENU_LIST,
        method: 'GET'
    })

export const setCategoryMenuList = async props =>
    callApi({
        ...props,
        url: CATEGORY_MENU_LIST,
        method: 'POST'
    })

export const getAllCategories = async props =>
    callApi({
        ...props,
        url: ALL_CATEGORIES,
        method: 'POST'
    })

export const getAllProductCategories = async props =>
    callApi({
        ...props,
        url: ALL_PRODUCT_CATEGORIES,
        method: 'POST'
    })

export const getCategoryUrl = async props =>
    callApi({
        ...props,
        url: CATEGORY_URL,
        method: 'POST'
    })

export const getCategoryInfo = async props =>
    callApi({
        ...props,
        url: CATEGORY_INFO,
        method: 'POST'
    })

export const getLayouts = async props =>
    callApi({
        ...props,
        url: LAYOUTS,
        method: 'GET'
    })

export const setLayouts = async props =>
    callApi({
        ...props,
        url: LAYOUTS,
        method: 'POST'
    })

export const removeLayout = async props =>
    callApi({
        ...props,
        url: LAYOUT_REMOVE,
        method: 'POST'
    })

export const getColumns = async props =>
    callApi({
        ...props,
        url: COLUMNS,
        method: 'POST'
    })

export const setColumns = async props =>
    callApi({
        ...props,
        url: COLUMNS_ADD,
        method: 'POST'
    })

export const getCategoryBanners = async props =>
    callApi({
        ...props,
        url: CATEGORY_BANNERS,
        method: 'POST'
    })

export const getCategoryBanner = async props =>
    callApi({
        ...props,
        url: CATEGORY_BANNER,
        method: 'POST'
    })

export const updateCategoryBanner = async props =>
    callApi({
        ...props,
        url: CATEGORY_BANNER_UPDATE,
        method: 'POST'
    })

export const removeCategoryBanner = async props =>
    callApi({
        ...props,
        url: CATEGORY_BANNER_DELETE,
        method: 'POST'
    })

export const getAdditionalCss = async props =>
    callApi({
        ...props,
        url: ADDITIONAL_CSS,
        method: 'GET'
    })

export const setAdditionalCss = async props =>
    callApi({
        ...props,
        url: ADDITIONAL_CSS,
        method: 'POST'
    })

const generateHeader = type => {
    let header = {
        Accept: 'application/json, text/plain, */*',
        'Accept-Language': 'en-US,en;q=0.9',
        'Content-Type':
            type == 'MULTIPART'
                ? 'multipart/form-data'
                : 'application/json; charset=UTF-8'
    }
    return header
}

const generateApiUrl = (url, params) => {
    let apiUrl = url
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            apiUrl = apiUrl.replace(`:${key}`, params[key])
        }
    }
    return apiUrl
}

const callApi = async ({ url, params = {}, method, body = {}, type }) => {
    let apiUrl = generateApiUrl(url, params)
    let apiHeaders = generateHeader(type)
    let accessToken = localStorage.getItem('indymall_admin_access_token') || ''
    if (method == 'GET') {
        apiUrl = `${apiUrl}&token=${accessToken}`
    }
    apiUrl = `${apiUrl}&v=${new Date().getTime()}`

    body.token = accessToken
    let formData
    if (type == 'MULTIPART') {
        formData = new FormData()
        Object.keys(body).forEach(key => formData.append(key, body[key]))
    }

    try {
        let response = await axios({
            method,
            url: apiUrl,
            headers: apiHeaders,
            data: type == 'MULTIPART' ? formData : JSON.stringify(body)
        })
        return response.data
    } catch (error) {
        let errInfo = handleApiError(error)
        throw errInfo
    }
}

const handleApiError = ({ response }) => {
    if (response) {
        switch (response.status) {
            case 401:
                window.location.reload()
                return response.data
            case 422:
                window.location.hash = '#activate'
                return response.data
            case 406:
                notification.warning({
                    message: 'This is just a demo!',
                    description: 'You can buy this theme on indytheme.com'
                })
                return response.data
            default:
                return response.data
        }
    } else {
        // window.location.href = window.config.rootUrl + '/wp-admin'
        return null
    }
}
